import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CustomerComponent } from './customer/customer.component';
import { ErrorPageComponent } from './error-page/error-page.component';
import { UrlSerializer } from '@angular/router';
import { CustomUrlSerializer } from './shared/services/UrlSerializer/CustomUrlSerializer';
import { DefaultErrorPageComponent } from './default-error-page/default-error-page.component';
import { ErrorCustomerComponent } from './error-customer/error-customer.component';
import { ErrorMaintenanceComponent } from './error-maintenance/error-maintenance.component';



//Please dont change the routes and/or paths as it affects error handling via HttpErrorInterceptor
const routes: Routes = [
  { path: '', redirectTo: '/customer/all/en-US', pathMatch: 'full' },
  { path: 'customer/:action/:lang', component: CustomerComponent },
  { path: 'opt/:action/:lang/:accountId/:name/:zipcode',
  loadChildren: () => import('./opt/opt.module').then(m => m.OptModule)},
  { path: 'optout/:lang/:accountId/:name/:zipcode',
  loadChildren: () => import('./opt-out/opt-out.module').then(m => m.OptOutModule)},
  { path: 'alt/:action/:lang/:account',
  loadChildren: () => import('./alt/alt.module').then(m => m.AltModule)},
  { path: 'alt/:action/:lang',
  loadChildren: () => import('./alt/alt.module').then(m => m.AltModule)},
  { path: 'altconfirmation/:action/:lang',
  loadChildren: () => import('./altconfirmation/altconfirmation.module').then(m => m.AltconfirmationModule)},

  { path: 'error/notfound/:action/:lang/:error', component: ErrorCustomerComponent },
  { path: 'error/maintenance/:lang', component: ErrorMaintenanceComponent },
  { path: 'error/:action/:lang', component: ErrorPageComponent },
  { path: 'error/:lang', component: DefaultErrorPageComponent },
  { path: '**', redirectTo: 'error/en-US' }
];

@NgModule({
  exports: [
    RouterModule
  ],
  imports: [
    RouterModule.forRoot(routes)
    ],
  providers: [
      { provide: UrlSerializer, useClass: CustomUrlSerializer }
  ]
})
export class AppRoutingModule { }
